import { render, staticRenderFns } from "./ResultsStructure.vue?vue&type=template&id=7d6b3e22&"
import script from "./ResultsStructure.vue?vue&type=script&lang=js&"
export * from "./ResultsStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports